import { OrderType } from "../interfaces/order";

export type CreateOrderDto = {
  customerId: string;
  items: any[];
  date?: string;
};

// Order Item Interfaces
interface ServiceOrder {
  type: OrderType.SERVICE_ORDER;
  serviceItems: Selection[];
}

interface MembershipOrder {
  type: OrderType.MEMBERSHIP;
  amount: number;
}

interface VoucherOrder {
  type: OrderType.VOUCHER;
  code: string;
  amount: number;
}

type OrderItem = ServiceOrder | MembershipOrder | VoucherOrder;

type Item = {
  serviceId: string;
  quantity: number;
};

export type CreateBillDto = {
  orderId: string;
  paymentMode: PaymentMode;
  includeTax?: boolean;
};

export type UpdateBillDto = {
  paid: boolean;
  paymentMode: PaymentMode;
};

export enum PaymentMode {
  CASH = "CASH",
  UPI = "UPI",
  CARD = "CARD",
}
